import React, { useEffect, useRef } from "react";

export const About = (props) => {
  const aboutRef = useRef(null);

  useEffect(() => {
    const currentAbout = aboutRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (currentAbout) {
      observer.observe(currentAbout);
    }

    return () => {
      if (currentAbout) {
        observer.unobserve(currentAbout);
      }
    };
  }, []);

  const renderParagraphs = () => {
    if (!props.data) return <p className="paragraph">loading...</p>;

    const paragraphs = [];
    for (let i = 0; i <= 10; i++) {
      const key = i === 0 ? "paragraph" : `paragraph${i}`;
      if (props.data[key]) {
        paragraphs.push(
          <p className="paragraph" key={key}>
            {props.data[key]}
          </p>
        );
      }
    }
    return paragraphs;
  };

  return (
    <div id="about" ref={aboutRef}>
      <div className="container">
        <div className="row d-flex">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <span className="about-eyebrow">Sobre a XisPay</span>
              <h2>
                Conheça a {props.data ? props.data.nameBank : "XisPay"}
              </h2>

              {renderParagraphs()}

              <h3>XisPay: Veloz. Seguro. Simples.</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-md-6 d-flex">
            <div className="about-visual">
              <span className="about-visual-halo" aria-hidden="true" />
              <img
                src="/img/bout.png"
                className="img-responsive about-photo"
                alt="Equipe XisPay em ambiente corporativo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
